import { render, staticRenderFns } from "./changeRoleEnterprise.vue?vue&type=template&id=825981e8&scoped=true"
import script from "./changeRoleEnterprise.vue?vue&type=script&lang=js"
export * from "./changeRoleEnterprise.vue?vue&type=script&lang=js"
import style0 from "./changeRoleEnterprise.vue?vue&type=style&index=0&id=825981e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "825981e8",
  null
  
)

export default component.exports